// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__vqT72","shimmer":"Skeleton_shimmer__-AHmA","pulse":"Skeleton_pulse__iL3O8","wave":"Skeleton_wave__ECXrN"};